<template>
  <div>
    <CrudList
      title="Opciones"
      storeName="Options"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      :canOther="true"
      labelOther="Respuestas"
      urlOther="answers"
      next-link="/admin/trakers"
      :breadcrumbs="[
        {
          text: 'Reservas y estadías',
          disabled: false,
          href: '/admin/options'
        },
        {
          text: 'Opciones',
          disabled: false,
          href: '#'
        },
      ]"
    >
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
